import { axios, Response } from '../index'

const deleteChecklistItem = (
  companyId: string,
  personaType: string,
  personaId: string,
  checklistItemId: string,
  taskId: string,
  checklistId: string
): Response<null> => {
  return axios.delete(
    `/v1/tasks/${taskId}/checklists/${checklistId}/checklist-items/${checklistItemId}`,
    {
      headers: {
        'X-CompanyID': companyId,
        'X-PersonaType': personaType,
        'X-PersonaID': personaId
      }
    }
  )
}

export default deleteChecklistItem
